import { render, staticRenderFns } from "./MoneyBlockItemStatistic.vue?vue&type=template&id=1a41821a&scoped=true&"
import script from "./MoneyBlockItemStatistic.vue?vue&type=script&lang=ts&"
export * from "./MoneyBlockItemStatistic.vue?vue&type=script&lang=ts&"
import style0 from "./MoneyBlockItemStatistic.vue?vue&type=style&index=0&id=1a41821a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a41821a",
  null
  
)

export default component.exports